/**
 * Completed campaign tiles (logged in): Yotpo replaces the points line with the
 * word "Completed", but the design keeps showing the points next to a check
 * badge. The points are still in the tile's aria-label
 * ("20 points Join our program. For further actions, …"), so read them back
 * from there.
 *
 * The widget is a Vue app, so this script deliberately stays light-handed:
 * - it only writes a data- attribute, which Vue does not manage (Vue rewrites
 *   `class` wholesale on every update, and fighting it caused a render loop);
 * - it writes only when the value changes;
 * - it observes childList only, never attributes, so it never reacts to its
 *   own writes;
 * - it runs at most once per animation frame, so even if Yotpo re-renders
 *   continuously the page cannot lock up.
 * The CSS shows the value with `content: attr(data-ylty-points)`.
 */
(() => {
  const sections = document.querySelectorAll('.ylty-earn');
  if (!sections.length) return;

  const ATTR = 'data-ylty-points';

  // Language independent: the points are whatever precedes the campaign action
  // text in the label, so the translated instruction suffix never matters.
  const pointsFor = (tile) => {
    const wrapper = tile.closest('.yotpo-campaign-switcher-wrapper');
    const label = wrapper && wrapper.getAttribute('aria-label');
    const desc = tile.querySelector('.yotpo-description-text');
    const action = desc && desc.textContent.trim();
    if (!label || !action) return '';
    const at = label.indexOf(action);
    return at > 0 ? label.slice(0, at).trim() : '';
  };

  const restore = (section) => {
    section.querySelectorAll('.yotpo-tile-completed').forEach((tile) => {
      const center = tile.querySelector('.yotpo-headline-center-element');
      if (!center) return;
      const points = pointsFor(tile);
      if (points && center.getAttribute(ATTR) !== points) center.setAttribute(ATTR, points);
    });
  };

  sections.forEach((section) => {
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        restore(section);
      });
    };
    restore(section);
    new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
  });
})();
